import { useTranslations } from 'next-intl';
import type { ReactNode } from 'react';
import { ClientLink } from '@/app/components/shared/ClientLink';
import { CardDescription, CardFooter } from '@/app/components/ui/card';
import { Checkbox } from '@/app/components/ui/checkbox';
import { SITE } from '@/app/constants';
import { reportEvent } from '@/app/utils';

interface LoginCardFooterProps {
  showConsentMarketingMsg: boolean;
  consentMarketingMsg: boolean;
  setConsentMarketingMsg: (consentMarketingMsg: boolean) => void;
  agreedTerms: boolean;
  setAgreedTerms: (agreedTerms: boolean) => void;
}

export const LoginCardFooter = ({
  showConsentMarketingMsg,
  consentMarketingMsg,
  setConsentMarketingMsg,
  agreedTerms,
  setAgreedTerms,
}: LoginCardFooterProps) => {
  const t = useTranslations();
  return (
    <CardFooter className="flex flex-col items-start justify-center p-0 text-center">
      {SITE === 'global' && showConsentMarketingMsg && (
        <div className="mb-2 text-system-white64 text-xs">
          <Checkbox
            className="me-1 align-middle text-base text-system-white leading-5"
            checked={consentMarketingMsg}
            onCheckedChange={() => {
              setConsentMarketingMsg(!consentMarketingMsg);
              if (!consentMarketingMsg) {
                reportEvent('element_click', {
                  element_name: 'email_ subscribe_ button_click',
                  from_page: 'signup_page',
                });
              }
            }}
          />
          <span className="leading-5">{t('login.consentMarketingMsg')}</span>
        </div>
      )}
      <CardDescription className="text-left text-system-white64 text-xs">
        {SITE === 'global' ? (
          t.rich('login.footer', {
            term: (chunks: ReactNode) => (
              <ClientLink className="text-system-white underline underline-offset-4" href="/terms" target="_blank">
                {chunks}
              </ClientLink>
            ),
            privacy: (chunks: ReactNode) => (
              <ClientLink className="text-system-white underline underline-offset-4" href="/privacy" target="_blank">
                {chunks}
              </ClientLink>
            ),
          })
        ) : (
          <div className="inline-flex items-start gap-1">
            <Checkbox
              className="mt-0.5 shrink-0 text-base text-system-white leading-5"
              checked={agreedTerms}
              onCheckedChange={() => setAgreedTerms(!agreedTerms)}
            />
            <span className="leading-5">
              勾选即表示本人阅读并同意
              <ClientLink
                className="text-system-white underline underline-offset-4"
                href="/terms"
                target="_blank"
                onClick={(e) => e.stopPropagation()}
              >
                《用户协议》
              </ClientLink>
              <ClientLink
                className="text-system-white underline underline-offset-4"
                href="/privacy"
                target="_blank"
                onClick={(e) => e.stopPropagation()}
              >
                《隐私协议》
              </ClientLink>
              <ClientLink
                className="text-system-white underline underline-offset-4"
                href="/personal-info-collection"
                target="_blank"
                onClick={(e) => e.stopPropagation()}
              >
                《个人信息收集清单》
              </ClientLink>
              <ClientLink
                className="text-system-white underline underline-offset-4"
                href="/personal-info-sharing"
                target="_blank"
                onClick={(e) => e.stopPropagation()}
              >
                《个人信息共享清单》
              </ClientLink>
              的全部内容
            </span>
          </div>
        )}
      </CardDescription>
    </CardFooter>
  );
};
